import { useCallback, useEffect, useState } from "react";
import ApiRequestLogService from "../../../services/ApiRequestLogService";
import { ApiRequestLogResponse } from "../../shared/entities/ApiRequestLogResponse";
import { TranslationService } from "../../../services/TranslationService";
import Table, { TableHeader } from "../../shared/Table";
import TableContext, { TableContextValues } from "../../task/TableContext";
import ApiRequestLogDetail from "./ApiRequestLogDetail";
import { ModalService, ModalParams } from "../../shared/bootstrap/modal/Modal";

const PAGE_SIZE = 20;

const tableHeaders: TableHeader[] = [
  new TableHeader("ApiRequestLogID", "ID", false, false),
  new TableHeader("Created", "Fecha", false, false),
  new TableHeader("Method", "Método", false, false),
  new TableHeader("Ok", "Exitoso", false, false),
  new TableHeader("Count", "Recibidos", false, false),
  new TableHeader("Processed", "Procesados", false, false),
  new TableHeader("Completed", "Completado", false, false)
];

const ApiRequestLog = () => {
  const [response, setResponse] = useState<ApiRequestLogResponse>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, _setCurrentPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(1);
  const [pageSize] = useState<number>(PAGE_SIZE);

  const requestData = async () => {
    setLoading(true);
    const result = await ApiRequestLogService.getList(currentPage, pageSize);
    if (result instanceof Error) {
      setError(true);
      setLoading(false);
      return;
    }
    const totalPages = Math.ceil(result.itemCount / result.pageSize);
    setResponse(result);
    setPageCount(totalPages);
    setLoading(false);
    setError(false);
  };

  const requestDataCallback = useCallback(requestData, [currentPage, pageSize]);

  useEffect(() => {
    requestDataCallback();
  }, [currentPage, requestDataCallback]);

  const setCurrentPage = (page: number) => {
    if (page >= 0 && page <= pageCount - 1) {
      _setCurrentPage(page);
    }
  };

  const tableContext = new TableContextValues<ApiRequestLogResponse>();
  tableContext.loading = loading;
  tableContext.error = error;
  tableContext.response = response;
  tableContext.currentPage = currentPage;
  tableContext.setCurrentPage = setCurrentPage;
  tableContext.pageCount = pageCount;
  tableContext.reload = requestData;
  tableContext.pageSize = pageSize;

  const openDetailModal = (id: number) => {
    const p = new ModalParams();
    p.size = "modal-xl";
    p.title = "Detalle API Request";
    p.closeClickingOutside = true;
    p.children = (
      <ApiRequestLogDetail id={id} onClose={() => ModalService.hideModal()} />
    );
    ModalService.showModal(p);
  };

  const ApiRequestLogItem = ({
    data
  }: {
    data: ApiRequestLogResponse.Item;
  }) => (
    <tr
      key={data.ApiRequestLogID}
      style={{ cursor: "pointer" }}
      onClick={() => openDetailModal(data.ApiRequestLogID)}
    >
      <td>{data.ApiRequestLogID}</td>
      <td>{data.Created ? new Date(data.Created).toLocaleString() : ""}</td>
      <td>{data.Method}</td>
      <td>{data.Ok ? "Si" : "No"}</td>
      <td>{data.Count}</td>
      <td>{data.Processed}</td>
      <td>{data.Completed ? new Date(data.Completed).toLocaleString() : ""}</td>
    </tr>
  );

  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <h4 className="mb-2">{TranslationService.translate.ApiRequestLog}</h4>
        <div className="card">
          <div className="d-flex align-items-center justify-content-end mb-2 gap-2">
            <button className="btn btn-primary" onClick={requestDataCallback}>
              {TranslationService.translate.Refresh}
            </button>
          </div>
          <TableContext.Provider value={tableContext}>
            <Table headers={tableHeaders} item={ApiRequestLogItem} />
          </TableContext.Provider>
        </div>
      </div>
    </div>
  );
};

export default ApiRequestLog;
